<template>
  <a-modal
    title="Crear / Editar"
    :visible="visible"
    width="80%"
    :confirm-loading="confirmLoading"
    @ok="guardar"
    @cancel="cancelar"
  >
  <a-form-model :model="iForm" v-bind="fiOptions" :rules="formRules"
                 ref="form">
    <a-row :gutter="[16,16]">
      <a-col v-bind="colSpan">
        <a-form-model-item :label="$t('Tipo de informe')" prop="id_h_call_motive" has-feedback>
          <form-model-dropdown style="width: 100%"
                               v-model="iForm.id_h_call_motive"
                               endpoint="hierarchy_lookup"
                               :params="request.tipo_de_informe"
          ></form-model-dropdown>
        </a-form-model-item>
      </a-col>
      <a-col v-bind="colSpan">
        <a-form-model-item :label="$t('Fecha del evento')" prop="call_date" has-feedback>
          <a-date-picker style="width: 100%"
                         type="date"
                         valueFormat="Y-MM-DD HH:mm:ss"
                         v-model="iForm.call_date"/>
        </a-form-model-item>
      </a-col>
      <a-col v-bind="colSpan">
        <a-form-model-item :label="$t('Involucrado')" prop="id_emp" has-feedback>
          <form-model-lookup style="width: 100%"
                             endpoint="empleados"
                             :params="{estado_activo: true}"
                             v-model="iForm.id_emp"
          >
          </form-model-lookup>
        </a-form-model-item>
      </a-col>
      <a-col v-bind="colSpan">
        <a-form-model-item :label="$t('Identificación novedad')" prop="id_h_novelty" has-feedback>
          <form-model-dropdown style="width: 100%"
                               v-model="iForm.id_h_novelty"
                               endpoint="hierarchy_lookup"
                               :params="request.identificacion_novedad"
                               :selectedObj.sync="novelty"
          ></form-model-dropdown>
        </a-form-model-item>
      </a-col>
      <a-col v-if="isOtherNovelty" v-bind="colSpan">
        <a-form-model-item :label="$t('Novedad')" prop="other_novelty">
          <a-input v-model="iForm.other_novelty" type="textarea" />
        </a-form-model-item>
      </a-col>
      <a-col v-bind="colSpan">
        <a-form-model-item :label="$t('Observación')" prop="call_obs">
          <a-input v-model="iForm.call_obs" type="textarea" />
        </a-form-model-item>
      </a-col>
      <a-col v-bind="colSpan">
        <div class="clearfix">
          <a-tooltip>
            <template slot="title">
              {{photoMessage}}
            </template>
            <a-upload
              :beforeUpload="beforeUpload"
              list-type="picture-card"
              :file-list="fileList"
              @preview="handlePreview"
              @change="handleChange"
              :disabled="photoDisabled"
            >
              <div v-if="fileList.length < maxFiles">
                <a-icon type="plus" />
                <div class="ant-upload-text">
                  REGISTRO FOTOGRÁFICO
                </div>
              </div>
            </a-upload>
          </a-tooltip>
          <a-modal :visible="previewVisible" :footer="null" @cancel="handleCancel">
            <img alt="example" style="width: 100%" :src="previewImage" />
          </a-modal>
        </div>
      </a-col>
    </a-row>
  </a-form-model>
  </a-modal>
</template>

<script>
  import HttpUtil from '@/util/HttpUtil'
  import Mensajes from 'CustomModules/GlobalBPOCore/Util/Mensajes'
  const MAX_FILES = 10

  function getBase64 (file) {
    return new Promise((resolve, reject) => {
      const reader = new FileReader()
      reader.readAsDataURL(file)
      reader.onload = () => resolve(reader.result)
      reader.onerror = error => reject(error)
    })
  }

  export default {
    mounted () {
      this.httpClient = new HttpUtil()
    },
    data () {
      return {
        photoMessage: 'Puede agregar las fotos acá.',
        photoDisabled: false,
        record: {},
        novelty: {},
        previewVisible: false,
        previewImage: '',
        fileList: [],
        request: {
          tipo_de_informe: {
            h_lookup_type: 'TIPO_DE_INFORME_DISCIPLINARIO'
          },
          identificacion_novedad: {
            h_lookup_type: 'IDENTIFICACION_NOVEDAD_DISCIPLINARIO'
          }
        },
        colSpan: {xs: 24, sm: 12},
        fiOptions: {
          'label-col': {span: 8},
          'wrapper-col': {span: 16},
          'has-feedback': true
        },
        iForm: {},
        formRules: {},
        visible: false,
        confirmLoading: false,
        maxFiles: 0
      }
    },
    methods: {
      showModal (record = {}) {
        this.maxFiles = MAX_FILES
        if (record['id_atention']) {
          this.photoMessage = 'Espera un momento estamos validando que puedas subir fotos.'
          this.photoDisabled = true
          this.iForm = record
          this.httpClient.getInstance().get('atention_call_file/cant/' + record['id_atention'])
            .then(response => {
              let diferencia = this.maxFiles - response.data
              if (diferencia < 0) {
                this.maxFiles = 0
              } else {
                this.maxFiles = diferencia
                this.photoMessage = 'Puede agregar las fotos acá.'
              }
              this.$forceUpdate()
              this.photoDisabled = false
            })
        } else {
          this.iForm = {}
          this.photoMessage = 'Puede agregar las fotos acá.'
        }
        this.visible = true
      },
      beforeUpload (file) {
        if (this.validateFile(file)) {
        }
        return false
      },
      validateFile (file) {
        const typeMime = ['png', 'jpeg', 'jpg']
        let ext = file.type.split('/')[1]
        if (!typeMime.includes(ext)) {
          this.$message.error('Solo se pemiten archivos de extensión ' + typeMime.toString())
          return false
        }
        const isLt2M = file.size / 1024 / 1024 < 2
        if (!isLt2M) {
          this.$message.error('El tamaño del archivo no puede ser mayor a 2 Megas.')
          return false
        }
        return true
      },
      initFormRules () {
        this.formRules = {
          valor: [{required: false}]
        }
      },
      handleCancel () {
        this.previewVisible = false
      },
      async handlePreview (file) {
        if (!file.url && !file.preview) {
          file.preview = await getBase64(file.originFileObj)
        }
        this.previewImage = file.url || file.preview
        this.previewVisible = true
      },
      handleChange ({ fileList }) {
        this.fileList = fileList
      },
      guardar () {
        this.confirmLoading = true
        let reqFormData = new FormData()
        if (this.fileList.length > 0) {
          for (let i = 0; i < this.fileList.length; i++) {
            reqFormData.append('files[]', this.fileList[i].originFileObj)
          }
        }
        if (!this.isOtherNovelty) {
          this.iForm.other_novelty = null
        }
        this.iForm.sanction = false
        this.iForm.disapproval = false
        reqFormData.append('iform', JSON.stringify(this.iForm))
        this.httpClient.getInstance().post('atention_call', reqFormData)
          .then(() => {
            Mensajes.success('Correcto', 'Datos guardados correctamente')
            this.$emit('handleOk')
          })
          .catch(() => {
            Mensajes.error('Error', 'No fue posible guardar la información, contacte al administrador.')
          }).then(() => {
            this.clearFields()
          })
      },
      cancelar () {
        this.visible = false
      },
      clearFields () {
        this.confirmLoading = false
        this.visible = false
        this.iForm = {}
        this.fileList = []
      }
    },
    computed: {
      isOtherNovelty () {
        return this.novelty && this.novelty.text === 'OTRO'
      }
    }
  }
</script>

<style>
  /* you can make up upload button and sample style by using stylesheets */
  .ant-upload-select-picture-card i {
    font-size: 32px;
    color: #999;
  }

  .ant-upload-select-picture-card .ant-upload-text {
    margin-top: 8px;
    color: #666;
  }
</style>


// WEBPACK FOOTER //
// src/customization/GlobalBPOCore/pages/ReporteNovedad/FormProcesoDisciplinario.vue